import { defineMessages } from 'react-intl'

export default defineMessages({
  strongPassword: {
    id: 'containers.UserSignIn.components.ConfirmRecover.strongPassword',
    defaultMessage: 'Select a new strong password, and type it in twice',
  },
  password: {
    id: 'containers.UserSignIn.components.ConfirmRecover.password',
    defaultMessage: 'Password',
  },
  repeatPassword: {
    id: 'containers.UserSignIn.components.ConfirmRecover.repeatPassword',
    defaultMessage: 'Repeat password',
  },
  recovering: {
    id: 'containers.UserSignIn.components.ConfirmRecover.recovering',
    defaultMessage: 'Recovering..',
  },
  recover: {
    id: 'containers.UserSignIn.components.ConfirmRecover.recover',
    defaultMessage: 'Recover',
  },
  havingTrouble: {
    id: 'containers.UserSignIn.components.ConfirmRecover.havingTrouble',
    defaultMessage: 'Still having trouble?',
  },
  getInTouch: {
    id: 'containers.UserSignIn.components.ConfirmRecover.getInTouch',
    defaultMessage: 'Get in touch with us',
  },
})
